module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "everyone"
  }, [_c('header-bar'), _vm._v(" "), (!_vm.uiHideInstructions) ? _c('section', {
    staticClass: "instructions background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "vertical-align"
  }, [_c('h3', [_vm._v("This is everyone who has signed up to the PEI exChange. Tap to view their profile.")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    on: {
      "click": _vm.hideInstructions
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "filter",
    class: {
      noinstructions: _vm.uiHideInstructions
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chunkArray),
      expression: "chunkArray"
    }],
    staticClass: "matches"
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('user-row', {
      key: row,
      attrs: {
        "data": row
      }
    })
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "shift-1 col-4"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbe39f5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Everyone.vue
// module id = 733
// module chunks = 1